<div class="pl-life-act flex w-full flex-col gap-4 bg-pl-gray-100 p-5 shadow-md">
  <h3 *ngIf="title" class="truncate text-pl-gray-500">{{ title }}</h3>
  <h4 *ngIf="subTitle" class="pl-inner-html !whitespace-pre-wrap text-pl-gray-450" [innerHTML]="subTitle"></h4>
  <p *ngIf="description" class="pl-inner-html text-lg text-pl-gray-450" [innerHTML]="description"></p>
  <div class="flex flex-col gap-4 xxs:h-14 xxs:flex-row">
    <pl-button class="h-full w-full xxs:!w-fit" [variant]="ButtonVariant.lightGray" (click)="onAddToCalendarClicked()">
      <div class="flex items-center gap-4">
        <pl-icon [name]="PlIcon.calendar_add" class="h-8 w-8" />
        <span class="block">{{ 'blocks.lifeAct.add_to_calendar' | translate }} </span>
      </div>
    </pl-button>
    <pl-button
      class="h-full w-full xxs:!w-[190px]"
      [isDisabled]="isDisabled"
      [variant]="markAsComplete() ? ButtonVariant.orange : ButtonVariant.gray"
      (click)="toggleMarkAsComplete()"
    >
      <div class="flex items-center gap-2">
        <ng-container *ngIf="markAsComplete(); else notComplete">
          <pl-icon [name]="PlIcon.tick" class="h-8 w-8" />
          <span class="block xxs:hidden sm:block">
            {{ 'blocks.lifeAct.completed' | translate }}
          </span>
        </ng-container>
        <ng-template #notComplete>
          <span class="block">
            {{ 'blocks.lifeAct.mark_complete' | translate }}
          </span>
        </ng-template>
      </div>
    </pl-button>
  </div>

  <mat-expansion-panel [(expanded)]="isPanelOpen" class="rounded-0 !shadow-none">
    <mat-expansion-panel-header>
      <div class="flex items-center gap-2">
        <p class="font-sans text-base">
          {{ (isPanelOpen ? 'blocks.lifeAct.hide_notes' : 'blocks.lifeAct.show_notes') | translate }}
        </p>
        <div
          class="h-0 w-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-pl-orange-800 transition-all"
          [ngClass]="{ 'rotate-180': isPanelOpen }"
        ></div>
      </div>
    </mat-expansion-panel-header>
    <div>
      <pl-textarea
        [label]="''"
        [showBorderValidationColor]="false"
        [isDisabled]="isDisabled"
        [placeholder]="'blocks.lifeAct.add_your_notes' | translate"
        [showRightIcon]="false"
        [ngModel]="note"
        (ngModelChange)="onNoteChange($event)"
        [ngModelOptions]="{ updateOn: 'blur' }"
      />
    </div>
  </mat-expansion-panel>
</div>
